/*!

=========================================================
* Argon Dashboard React - v1.2.4
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2024 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import { Container, Row, Col } from "reactstrap";

const KADEKON_LOGO_SRC = `${process.env.PUBLIC_URL}/kadekon-logo.png`;
const EFSANELER_LOGO_SRC = `${process.env.PUBLIC_URL}/efsaneler-logo.png`;
const EFSANELER_HOME_URL = "https://efsaneler.karadenizdestinasyonu.com.tr/";

const AuthFooter = () => {
  return (
    <footer className="footer">
      <Container>
        <Row className="align-items-center justify-content-xl-between">
          <Col xs="12" md="6" xl="6" className="mb-3 mb-md-0">
            <div className="copyright text-center text-xl-left text-muted">
              © 2026
            </div>
          </Col>

          <Col xs="12" md="6" xl="6">
            <div className="text-center text-xl-right text-muted">
              <div
                className="d-flex align-items-center justify-content-center justify-content-xl-end flex-wrap"
                style={{ gap: 12 }}
              >
                <a
                  href="https://karadenizdestinasyonu.com.tr"
                  aria-label="Karadeniz Destinasyonu"
                  className="mt-2 mt-xl-0"
                >
                  <img
                    src={KADEKON_LOGO_SRC}
                    alt="Karadeniz Dernekleri Konfederasyonu"
                    loading="lazy"
                    style={{ height: 80, width: "auto", objectFit: "contain" }}
                  />
                </a>

                <a
                  href={EFSANELER_HOME_URL}
                  aria-label="Karadeniz Efsaneleri"
                  className="mt-2 mt-xl-0"
                >
                  <img
                    src={EFSANELER_LOGO_SRC}
                    alt="Karadeniz Efsaneleri"
                    loading="lazy"
                    style={{ height: 74, width: "auto", objectFit: "contain" }}
                    onError={(e) => {
                      e.currentTarget.style.display = "none";
                    }}
                  />
                </a>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default AuthFooter;
